import { createInjectionState, useMediaQuery } from '@vueuse/core'
import { computed, ref } from 'vue'

const [useProvideSlideoverStore, useSlideoverStore] = createInjectionState(
  () => {
    const isLargeScreen = useMediaQuery('(min-width: 1280px)')

    const slideoversOpen = ref([])

    const defaultWidth = 448
    const slideoverSize = ref(defaultWidth)

    const openSlideover = (instance, initialWidth, closeCallback) => {
      // Until we implement a tab system for multiple slideovers, just close any open slideovers before opening a new one
      slideoversOpen.value.forEach((o) => {
        o.closeCallback()
      })

      slideoverSize.value = initialWidth
      slideoversOpen.value.push({
        instance,
        initialWidth,
        closeCallback,
      })
    }

    const closeSlideover = (instance) => {
      slideoversOpen.value = slideoversOpen.value.filter(
        (o) => o.instance.uid !== instance.uid
      )
    }

    const slideoverIsOpen = computed(() => slideoversOpen.value.length > 0)

    const asideColumnIsOpen = computed(
      () => slideoverIsOpen.value && isLargeScreen.value
    )

    return {
      isLargeScreen,
      slideoverSize,
      openSlideover,
      closeSlideover,
      slideoverIsOpen,
      asideColumnIsOpen,
    }
  },
  { injectionKey: Symbol('SlideoverStore') }
)

export { useProvideSlideoverStore, useSlideoverStore }
